import { render, staticRenderFns } from "./ImpactionPointsDialog.vue?vue&type=template&id=3772ad22&"
import script from "./ImpactionPointsDialog.vue?vue&type=script&lang=js&"
export * from "./ImpactionPointsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports